function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.13 1.52a2.74 2.74 0 00.66.33l.79.27q.5.16 1 .35a3.69 3.69 0 01.94.53 2.55 2.55 0 01.68.8A3.13 3.13 0 003.14 0a3.11 3.11 0 00-1.59.45 1.32 1.32 0 00.15.62 1.46 1.46 0 00.43.45zM4.88 4.4a1.67 1.67 0 00-.51-.51 3.43 3.43 0 00-.75-.36l-.9-.3a7.82 7.82 0 01-.93-.34A3.26 3.26 0 011 2.37a2.39 2.39 0 01-.58-.71A3.11 3.11 0 000 3.14a3.13 3.13 0 005 2.53 1.49 1.49 0 00.09-.52 1.38 1.38 0 00-.21-.75z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.21 3.8a2.55 2.55 0 00-.69-.8 3.69 3.69 0 00-.94-.52q-.5-.19-1-.35l-.79-.27a2.74 2.74 0 01-.66-.33 1.46 1.46 0 01-.43-.46 1.32 1.32 0 01-.15-.62A3.13 3.13 0 00.39 1.66a2.39 2.39 0 00.61.71 3.26 3.26 0 00.83.52 7.82 7.82 0 00.93.34l.9.3a3.43 3.43 0 01.75.36 1.67 1.67 0 01.51.51 1.38 1.38 0 01.19.75 1.49 1.49 0 01-.11.52A3.13 3.13 0 006.21 3.8z",
  fill: "#d2d2d2",
  className: "svg-no-adaptive-fill"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6.28 6.28"
  }, props), _ref, _ref2);
};

export default SvgComponent;